/**
 * 枚舉
 *
 * ⚠️⚠️ 注意 ⚠️⚠️
 * 枚舉除了根namespace以外, 請都使用扁平的enum
 * 且名稱至少要兩個英文單字組成
 * 因為 namespace 跟 enum 的名稱在 typescript 必須是 unique 的
 */

/**
 * 頭像 - 我的教會
 */
export const EnumAvatarAdmin = Object.freeze({

    /**
     * 教會封面圖
     */
    CHURCH: 3001,
    /**
     * 上傳
     */
    UPLOAD: 3002,
    /**
     * 圖庫
     */
    GALLERY: 3003,
    /**
     * 管理員管理
     */
    USER: 3004,
    /**
     * 會友管理
     */
    CLIENT: 3005,
    /**
     * 標籤管理
     */
    TAG: 3006,
    /**
     * 我的教會
     */
    MY: 3007,
    /**
     * 心靈捕手
     */
    SOUL: 3008,
    /**
     * 心靈捕手分類
     */
    SOUL_CATEGORY: 3009,
    /**
     * 每日靈糧
     */
    DAILY: 3010,
    /**
     * 編輯推播名單
     */
    RECIPIENT: 3011,
    /**
     * 編輯推播名單
     */
    MEMBERSHIP: 3012,
    /**
     * 教學管理
     */
    TEACH: 3013,
    /**
     * 存取紀錄
     */
    COURSE_ACCESS: 3014,
    /**
     * 存取紀錄
     */
    COURSE_AUTHORIZE: 3015,
    /**
     * 攔截紀錄
     */
    COURSE_EXCEPTION: 3016,

})
